import { render, staticRenderFns } from "./Ranks.vue?vue&type=template&id=1981a6d3&scoped=true&"
import script from "./Ranks.vue?vue&type=script&lang=js&"
export * from "./Ranks.vue?vue&type=script&lang=js&"
import style0 from "./Ranks.vue?vue&type=style&index=0&id=1981a6d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1981a6d3",
  null
  
)

export default component.exports